<script setup lang="ts">
import type { DialogEmits } from '#layers/ui/public';
import { useEmitAsProps } from 'reka-ui';

defineProps<{
	action?: string;
	collectionName: string;
}>();

const emit = defineEmits<DialogEmits>();
const forwarded = useEmitAsProps(emit);
</script>

<template>
	<DDialog
		v-bind="forwarded"
		:title="$t('policy.policy_rules.confirm_override_custom_title')"
		:confirm="{ label: $t('policy.policy_rules.confirm_override_custom_confirm') }"
	>
		<template #description>
			<i18n-t v-if="action" keypath="policy.policy_rules.confirm_override_custom_description" tag="span">
				<template #action>
					<span class="font-medium">{{ action }}</span>
				</template>
				<template #collectionName>
					<span class="font-medium">{{ collectionName }}</span>
				</template>
			</i18n-t>
			<i18n-t v-else keypath="policy.policy_rules.confirm_override_custom_all_actions_description" tag="span">
				<template #collectionName>
					<span class="font-medium">{{ collectionName }}</span>
				</template>
			</i18n-t>
		</template>
	</DDialog>
</template>
